$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();
	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();
	return elementBottom > viewportTop && elementTop < viewportBottom;
};

(function($) {
    "use strict";
    $(function() {

        if($('.circle-headline').length > 0) {
        	$(window).scroll(function(){
        		if($('.contact-ceo h6').isInViewport()) {
            		$('.circle-headline').removeClass('preload');
        		}
        	});
        }

    });
})(jQuery);